import { ProductType } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import productQueryKeys from "../query-keys/product.query-keys";

const organiserGetStructureProducts = async (
  structureId: string,
  eventId: string
) => {
  const { data } = await privateAxios.get<ProductType[]>(
    `/organiser-handle-structure/${structureId}/products?eventId=${eventId}`
  );
  return data;
};

export const useOrganiserGetStructureProductsQuery = (
  structureId: string,
  eventId: string
) => {
  return useQuery({
    queryKey: productQueryKeys.listFromOrganiser(structureId, eventId),
    queryFn: () => organiserGetStructureProducts(structureId, eventId),
  });
};
